import styled from 'styled-components';

const Avatar = styled.div`
  width: 30px;
  height: 30px;
  position: relative;
  border: 1px solid ${({ theme }) => theme.colors.text};
  border-radius: 100%;
  background: ${({ theme }) => theme.colors.text};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: ${({ theme }) => theme.colors.base};
`;

const Mention = styled.div`
  border-radius: 50%;
  width: 21px;
  height: 21px;
  padding-top: 1px;
  position: absolute;
  right: -2.5px;
  top: 5px;
  background-image: linear-gradient(0deg, #8a01d9 0%, rgba(164, 1, 217, 1) 90%);
  color: white;
  text-align: center;
  font-size: 11px;
  line-height: 11px;
  box-shadow: -3px 4px 20px #000;
  z-index: 10;
  animation: fadeInOutAni 3.5s infinite;
  border: 3px solid white;
  bottom: -3px;
`;

export const Styled = {
  Avatar,
  Mention,
};
